<div class="landing-page">
  <div class="container">
    <!-- Loading state -->
    @if (loading && !error) {
      <div class="loading-section">
        <app-loading message="Loading your projects..."></app-loading>
      </div>
    }

    <!-- Error state -->
    @if (error) {
      <div class="error-section">
        <div class="error-icon">
          <mat-icon>error_outline</mat-icon>
        </div>
        <h2>Something went wrong</h2>
        <p class="error-message">{{ error }}</p>
        <button mat-raised-button color="primary" (click)="retry()">Try Again</button>
      </div>
    }
  </div>
</div>
